__turbopack_context__.v({
  "grid": "styles-module__hGAAiq__grid",
  "head": "styles-module__hGAAiq__head",
  "icon": "styles-module__hGAAiq__icon",
  "name": "styles-module__hGAAiq__name",
  "root": "styles-module__hGAAiq__root",
  "sub": "styles-module__hGAAiq__sub",
  "tile": "styles-module__hGAAiq__tile",
  "tileSub": "styles-module__hGAAiq__tileSub",
  "title": "styles-module__hGAAiq__title",
});
